import vx from 'vx'
import * as FastClick from "fastclick"
import vxmobile from 'vx-mobile';

import vx3Plugin from './plugins/vx3Plugin';
import App from './App'
import router from './router'
import axios from './plugins/axios'
import store from './store';
import mixins from './modules'
import JSEncrypt from 'encryptlong'
import global from '@/assets/data/global'
import http from 'axios'

import wx from 'weixin-js-sdk'

// import share from './plugins/share.js'

import './plugins/vee-validate'
import './modules/responsive';

import "@/assets/css/base.css";
import "@/assets/css/realNameCertification.css";
//添加常用方法
import {sessionAndLocalStorage} from './modules/commonMethods'

// http.defaults.headers.post['Content-type'] = ['application/x-www-form-urlencoded']
// Vue.prototype.$wx = wx
vx.use(sessionAndLocalStorage);
vx.use(vx3Plugin);
vx.use(vxmobile);
vx.use(axios);
vx.mixin(mixins);
// vx.use(share);

FastClick.attach(document.body);
vx.config.devtools = true;
vx.config.productionTip = false;
vx.prototype.global = global;
vx.prototype.$http = http;
vx.prototype.$getRsaCode = function(val){
  //实例化一个JSEncrypt对象
  let encrypt = new JSEncrypt();
  encrypt.setPublicKey(this.global.publicKey);
  let encrypted = encrypt.encryptLong(val);
  return encrypted
};
vx.prototype.$resetRsaCode = function(val){
  //实例化一个JSEncrypt对象
  let encrypt = new JSEncrypt();
  encrypt.setPrivateKey(this.global.privateKey);
  //设置需要解密的字符串
  let decrypted = encrypt.decryptLong(val);
  return decrypted
};
// router.beforeEach((to, from, next) => {
//   alert(123)
//   // 特殊处理授权成功后的user个人中心页面点击返回退出到微信消息列表页
//   let mark = to.fullPath.indexOf('code')
//   if (mark !== -1 && from.fullPath === '/') {
//       wx.closeWindow()
//   }
// })
/* eslint-disable no-new */
vx.bootstrap({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js